

export function BannerImage({ url }) {
  return <div style={{ maxHeight: '500px', overflow: 'hidden' }}>
    <img src={url} style={{ width: '100%' }} />
  </div>
}
